import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OidcService } from '../../shared/services/oidc/oidc.service';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class OidcInterceptor implements HttpInterceptor {
    constructor(private oidcService: OidcService) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.oidcService.getValidToken$().pipe(
            switchMap((token) => {
                if (token) {
                    const headers: HttpHeaders = req.headers
                        .set('Content-Type', 'application/json')
                        .set('X-API-Key', environment.oidcClientId)
                        .set('Authorization', 'Bearer ' + token);
                    const req_cloned = req.clone({ headers, withCredentials: true });
                    return next.handle(req_cloned);
                } else {
                    return next.handle(req);
                }
            })
        );
    }
}
